"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCompaniesWithNonSaas = exports.selectAllCompaniesMap = exports.selectNonSaasServices = void 0;
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var react_redux_firebase_1 = require("react-redux-firebase");
var reselect_1 = require("reselect");
var utils_1 = require("utils/selectors/utils");
exports.selectNonSaasServices = (0, utils_1.makeSelectOrdered)('nonSaasServices');
exports.selectAllCompaniesMap = (0, utils_1.makeSelectData)('allCompanies');
exports.selectCompaniesWithNonSaas = (0, reselect_1.createSelector)((0, utils_1.makePopulate)('nonSaasServiceStats[]', ['service']), exports.selectAllCompaniesMap, function (serviceStats, allCompaniesMap) {
    if (!(0, react_redux_firebase_1.isLoaded)(serviceStats) || (0, react_redux_firebase_1.isEmpty)(serviceStats)) {
        return serviceStats;
    }
    var sStatsByCompany = (0, groupBy_1.default)(serviceStats, 'companyId');
    return Object.entries(sStatsByCompany)
        .map(function (_a) {
        var _b;
        var _c = __read(_a, 2), cId = _c[0], sStats = _c[1];
        return ({
            id: cId,
            companyName: ((_b = allCompaniesMap[cId]) === null || _b === void 0 ? void 0 : _b.name) || 'unknown',
            nonSaasServiceNames: sStats.map(function (sS) { return sS.service.name; }),
        });
    });
});
